var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkGreyBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2129 1.33398H5.78622C4.36622 1.33398 3.21289 2.49398 3.21289 3.90732V13.3007C3.21289 14.5007 4.07289 15.0073 5.12622 14.4273L8.37956 12.6207C8.72622 12.4273 9.28622 12.4273 9.62622 12.6207L12.8796 14.4273C13.9329 15.014 14.7929 14.5073 14.7929 13.3007V3.90732C14.7862 2.49398 13.6329 1.33398 12.2129 1.33398ZM11.0062 6.50065C10.3596 6.73398 9.67956 6.85398 8.99956 6.85398C8.31956 6.85398 7.63956 6.73398 6.99289 6.50065C6.73289 6.40732 6.59956 6.12065 6.69289 5.86065C6.79289 5.60065 7.07956 5.46732 7.33956 5.56065C8.41289 5.94732 9.59289 5.94732 10.6662 5.56065C10.9262 5.46732 11.2129 5.60065 11.3062 5.86065C11.3996 6.12065 11.2662 6.40732 11.0062 6.50065Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGreyBookmark);
export default __webpack_public_path__ + "static/media/dark_grey_bookmark.4f17b190a0983b9a41c84ec9a48868b5.svg";
export { ForwardRef as ReactComponent };